// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"close-octagon"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M8.06595 2.49951L15.936 2.49951L21.501 8.06448V15.9345L15.936 21.4995H8.06595L2.50098 15.9345L2.50098 8.06448L8.06595 2.49951Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8.06497 2.49963L15.935 2.49963L21.5 8.06461V15.9347L15.935 21.4996H8.06497L2.5 15.9347L2.5 8.06461L8.06497 2.49963Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M15.1823 8.818L12.0007 11.9996M12.0007 11.9996L8.81836 15.182M12.0007 11.9996L15.1823 15.1813M12.0007 11.9996L8.81836 8.81732","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-close-octagon')
export default class CloseOctagonIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'close-octagon',
    }
  }
}
